import { isDXTerminal } from '@/lib/kjs-wrapper';

/** フラグ */
export const flg = {
  /** 偽 */
  OFF: 0,
  /** 真 */
  ON: 1,
  /** その他 */
  ETC: 9
};

/** 入力モード */
export const inputMode = {
  /** 手入力 */
  KEY: 1,
  /** ＯＣＲ */
  OCR: 2,
  /** バーコード */
  BARCODE: 4
};

/** 文字列 */
export const str = {
  /** 全角スペース */
  SPACE_FULL: '\u3000',
  /** 改行 */
  NEW_LINE: '\n'
};

/** バーコード種類(Android) */
export const codeTypeAndroid = {
  /** CODE39 */
  CODE39: 'code_39',
  /** CODE93 */
  CODE93: 'code_93',
  /** CODE128 */
  CODE128: 'code_128',
  /** QRコード */
  QR_CODE: 'qr_code',
  /** Data Matrix */
  DATA_MATRIX: 'data_matrix',
  /** PDF417 */
  PDF_417: 'pdf417'
};

/** バーコード種類(DX端末) */
export const codeTypeDXTerm = {
  /** CODE39 */
  CODE39: 'code39',
  /** CODE93 */
  CODE93: 'code93',
  /** CODE128 */
  CODE128: 'code128',
  /** QRコード */
  QR_CODE: 'qrCode',
  /** Data Matrix */
  DATA_MATRIX: 'datamatrix',
  /** PDF417 */
  PDF_417: 'pdf417',
  /** OCR */
  OCR: 'ocr'
};

/** バーコード種類 */
export const codeType = {
  /** キーボード入力 */
  KEYBOARD: 'Keyboard',
  /** CODE39 */
  CODE39: isDXTerminal() ? codeTypeDXTerm.CODE39 : codeTypeAndroid.CODE39,
  /** CODE93 */
  CODE93: isDXTerminal() ? codeTypeDXTerm.CODE93 : codeTypeAndroid.CODE93,
  /** CODE128 */
  CODE128: isDXTerminal() ? codeTypeDXTerm.CODE128 : codeTypeAndroid.CODE128,
  /** QRコード */
  QR_CODE: isDXTerminal() ? codeTypeDXTerm.QR_CODE : codeTypeAndroid.QR_CODE,
  /** Data Matrix */
  DATA_MATRIX: isDXTerminal() ? codeTypeDXTerm.DATA_MATRIX : codeTypeAndroid.DATA_MATRIX,
  /** PDF417 */
  PDF_417: isDXTerminal() ? codeTypeDXTerm.PDF_417 : codeTypeAndroid.PDF_417,
  /** OCR */
  OCR: isDXTerminal() ? codeTypeDXTerm.OCR : ''
};

/** スキャン結果 */
export const scanResult = {
  /** 成功 */
  SUCCESS: 'SUCCESS',
  /** 失敗 */
  FAILED: 'FAILED'
};

/** 重複許可区分 */
export const allowDup = {
  /** 重複OK */
  DUP_OK: '1',
  /** 重複NG */
  DUP_NG: '2',
  /** 重複排除 */
  DUP_DEL: '3'
};

/** データレイアウト */
export const dataLayout = {
  /** ヘッダ */
  HEADER: '1',
  /** 明細 */
  DETAIL: '2'
};

/** データ区切り */
export const dataSplit = {
  /** 固定長 */
  FIXED: '1',
  /** 可変長 */
  VARIABLE: '2'
};

/** 項目タイプ */
export const columnType = {
  /** 文字列 */
  TEXT: '1',
  /** 数値 */
  NUMBER: '2',
  /** 日付 */
  DATE: '3'
};

/** 端末情報 */
export const termInfo = {
  /** キー保存ディレクトリ */
  KEY_DIR: 'FreeCheck',
  /** キー */
  KEY: 'term_info',
  /** Android識別 */
  ANDROID_ID: 'android'
};

/** 画面状態 */
export const viewSts = {
  /** 初期 */
  INIT: 0,
  /** 読取ルール選択後 */
  READ_RULE: 1,
  /** 照合予定ヘッダ読取中 */
  ORDER_HEADER: 2,
  /** 照合予定明細読取中(読取実績読取中) */
  ORDER_DETAIL: 3,
  /** 照合実績読取中 */
  RESULT: 4,
  /** エラー */
  ERROR: -1
};

/** 日付フォーマット */
export const dtFormat = {
  /** 標準 */
  STD: 'yyyy-MM-dd HH:mm:ss.SSS',
  /** 一覧 */
  LIST: 'yyyy-MM-dd HH:mm',
  /** 日付 */
  DATE: 'yyyy/MM/dd',
  /** 時刻 */
  TIME: 'HH:mm:ss',
  /** ファイル用 */
  FILE: 'yyyyMMddHHmmssSSS'
};

/** データ制限 */
export const limitData = {
  /** 一覧項目数 */
  LIST_COLUMNS: 3,
  /** 単一ヘッダ数 */
  ONE_HEADERS: 3,
  /** 単一明細数 */
  ONE_DETAILS: 3
};

/** データ種類 */
export const dataType = {
  /** ログイン */
  LOGIN: '0',
  /** 照合実績 */
  COMPARE_RESULT: '1',
  /** 読取実績 */
  READ_RESULT: '2'
};

/** 照合モード */
export const compareMode = {
  /** 1：1照合 */
  ONE_TO_ONE: '1',
  /** 1：N照合 */
  ONE_TO_MANY: '2'
};

/** 完了状態 */
export const completeSts = {
  /** 実績なし */
  NO_RESULT: '0',
  /** 処理中 */
  PROCESSING: '1',
  /** NGあり完了 */
  COMPLETE_NG: '2',
  /** NGなし完了 */
  COMPLETE_OK: '3',
  /** 読取完了 */
  COMPLETE_READ: '4'
};
